import { GET_ALL_GAMES_RESULT } from "../../service/admin.service";
import Navbar from "../../Pages/Navbar/Navbar";
import Footer from "../../Pages/Footer/Footer_2";
import { nameRejext } from "../../Helpers/StringRejex";

import MayaMorning from "../../Charts/PanaCharts/MayaMorning";

import RIDDHIDAY from "../../Charts/PanaCharts/RIDDHIDAY";
import RIDDHIMORNING from "../../Charts/PanaCharts/RIDDHIMORNING";
import RIDDHINIGHT from "../../Charts/PanaCharts/RIDDHINIGHT";

import SIDDHIDAY from "../../Charts/PanaCharts/SIDDHIDAY";
import SIDDHIMORNING from "../../Charts/PanaCharts/SIDDHIMORNING";
import SIDDHINIGHT from "../../Charts/PanaCharts/SIDDHINIGHT";

import SHREEGANESH122 from "../../Charts/PanaCharts/SHREEGANESH";

import { GetAllCharts } from "../../Helpers/GetCharts";
import { PagesIndex } from "../../Pages/PagesIndex";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { common_chart_url } from "../../Config/config";

const Pana_Chart = () => {
  const navigate = PagesIndex.useNavigate();
  const { title } = useParams();
  const location = useLocation();

  const [getData, setgetData] = PagesIndex.useState([]);
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState("0px");
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  const handleClick = () => {
    const targetElement = document.getElementById("scroll-down");

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleClickUp = () => {
    const targetElement = document.getElementById("scroll-up");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const normalize = (str) =>
    str?.replace(/-/g, "").replace(/\s+/g, "").toUpperCase();

  const normalizedTitle = normalize(title);

  const getResponseData = async () => {
    const req = location.state;

    // const res = await GET_ALL_GAMES_RESULT({ id: req });
    const res = await GetAllCharts(GET_ALL_GAMES_RESULT, req);
    setgetData(res);
  };
  useEffect(() => {
    if (title) getResponseData();
  }, [title]);

  const chartMap = {
    // Maya
    MAYAMORNING: MayaMorning,

    // RIDDHI
    RIDHIDAY: RIDDHIDAY,
    RIDHIMORNING: RIDDHIMORNING,
    RIDHINIGHT: RIDDHINIGHT,

    // SIDDHI
    SIDHIDAY: SIDDHIDAY,
    SIDHIMORNING: SIDDHIMORNING,
    SIDHINIGHT: SIDDHINIGHT,
    // SHREEGANESH
    SHREEGANESH: SHREEGANESH122,
  };

  const ChartComponent = chartMap[normalizedTitle];

  // iframe fallback (TITLE BASED)
  const chartUrl = `${common_chart_url}pana-chart/${normalizedTitle}?embed=true&color=%23478767`;

  // iframe height listener
  useEffect(() => {
    if (ChartComponent) return;

    const handleMessage = (event) => {
      if (event.data?.type === "SET_HEIGHT") {
        const newHeight = `${event.data.height}px`;
        setIframeHeight(newHeight);
        if (iframeRef.current) {
          iframeRef.current.style.height = newHeight;
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [ChartComponent]);

  return (
    <>
      <div className="chart-home-page">
        <div id="scroll-up"></div>
        <Navbar />

        <div className="container-fluid ">
          <div className="row">
            <div className="text-center col-xl-12 col-q-12 col-md-12 col-sm-12 chart-header-table ">
              <div className="pt-110  text-alignment">
                <h2 className="chart-header-font">
                  <strong className="color-white">{normalizedTitle}</strong>
                </h2>

                <p className="color-white">
                  Discover {normalizedTitle} Pana Chart with historical records,
                  past results, live chart information, and complete number
                  details for a smooth and easy experience.
                </p>
              </div>
              <div className="d-flex alighn-item-center justify-content-center">
                <button
                  className="scroll-btn my-3"
                  onClick={handleClick}
                  id="scroll-down-button"
                >
                  Scroll Down
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="">
          <div className="row justify-content-center ">
            <div className="p-0 text-center d-flex justify-content-center   col-xl-12 col-q-12 col-md-12 col-sm-12">
              <div className="table-responsive  text-center col-xl-8 col-lg-12 col-md-12 col-sm-12 ">
                {ChartComponent ? (
                  <ChartComponent chartData={getData.data} />
                ) : (
                  <div
                    style={{
                      minHeight:
                        iframeHeight === "0px" ? "200px" : iframeHeight,
                      position: "relative",
                    }}
                  >
                    {/* Skeleton Loader */}
                    {isIframeLoading && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          padding: "20px",
                          background: "#fff",
                          zIndex: 10,
                        }}
                      >
                        <div className="skeleton-box"></div>
                        <div className="skeleton-box"></div>
                        <div className="skeleton-box"></div>
                      </div>
                    )}

                    {/* iframe */}
                    <iframe
                      ref={iframeRef}
                      src={chartUrl}
                      title="Charts"
                      onLoad={() => setIsIframeLoading(false)}
                      className="w-100 border-0 transition-all duration-500"
                      scrolling="no"
                      style={{
                        width: "100%",
                        height: iframeHeight,
                        opacity: isIframeLoading ? 0 : 1,
                      }}
                    />
                  </div>
                )}

                <button
                  className=" btn  rounded-pill back-btn "
                  onClick={() => navigate(-1)}
                  id="scroll-down-button"
                >
                  Back
                </button>
                <button
                  className=" btn rounded-pill back-btn "
                  onClick={handleClickUp}
                  id="scroll-down-button"
                >
                  Scroll to Top
                </button>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <div id="scroll-down"></div>
      </div>
    </>
  );
};

export default Pana_Chart;
